import { TypographyOptions } from '@mui/material/styles/createTypography';

const fontFamily = '"Inter", "Roboto", "Helvetica", "Arial", sans-serif';

export const typography: TypographyOptions = {
  htmlFontSize: 14,
  fontFamily: fontFamily,
  fontSize: 14,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 700,
  h1: {
    fontFamily: fontFamily,
    fontWeight: 600,
    fontSize: '6rem',
    lineHeight: 1.167,
    letterSpacing: '0em',
  },
  h2: {
    fontFamily: fontFamily,
    fontWeight: 600,
    fontSize: '3.75rem',
    lineHeight: 1.2,
    letterSpacing: '0em',
  },
  h3: {
    fontFamily: fontFamily,
    fontWeight: 600,
    fontSize: '3rem',
    lineHeight: 1.167,
    letterSpacing: '0em',
  },
  h4: {
    fontFamily: fontFamily,
    fontWeight: 600,
    fontSize: '2.125rem',
    lineHeight: 1.235,
    letterSpacing: '0em',
  },
  h5: {
    fontFamily: fontFamily,
    fontWeight: 600,
    fontSize: '1.5rem',
    lineHeight: 1.5,
    letterSpacing: '0em',
  },
  h6: {
    fontFamily: fontFamily,
    fontWeight: 600,
    fontSize: '1.25rem',
    lineHeight: 1.6,
    letterSpacing: '0em',
  },
  subtitle1: {
    fontFamily: fontFamily,
    fontWeight: 600,
    fontSize: '1rem',
    lineHeight: 1.75,
    letterSpacing: '0em',
  },
  subtitle2: {
    fontFamily: fontFamily,
    fontWeight: 600,
    fontSize: '0.875rem',
    lineHeight: 1.57,
    letterSpacing: '0em',
  },
  body1: {
    fontFamily: fontFamily,
    fontWeight: 400,
    fontSize: '1rem',
    lineHeight: 1.5,
    letterSpacing: '0em',
  },
  body2: {
    fontFamily: fontFamily,
    fontWeight: 400,
    fontSize: '0.875rem',
    lineHeight: 1.73,
    letterSpacing: '0em',
  },
  button: {
    fontFamily: fontFamily,
    fontWeight: 500,
    fontSize: '0.8125rem',
    lineHeight: 1.75,
    letterSpacing: '0.004em',
  },
  caption: {
    fontFamily: fontFamily,
    fontWeight: 400,
    fontSize: '0.75rem',
    lineHeight: 1.66,
    letterSpacing: '0.033em',
  },
  overline: {
    fontFamily: fontFamily,
    fontWeight: 400,
    fontSize: '0.75rem',
    lineHeight: 2.66,
    letterSpacing: '0em',
    textTransform: 'uppercase',
  },
};
